<template lang="pug">
v-dialog(v-model="dialog" width="350" persistent)
    template(v-slot:activator="{ on, attrs }")
        v-btn.mr-2(small color="teal" dark rounded v-bind="attrs" v-on="on")
            v-icon(x-small) fas fa-edit
            | &nbsp;Add Points
    v-card
        v-card-title Add Points
        v-card-text
            v-container
                v-text-field(type="number" v-model="form.value" label="Points" :disabled="loading")
        v-divider
        v-card-actions
            v-spacer
            v-btn(v-if="!loading" small color="red" text @click="dialog = false") Cancel
            v-btn(small color="primary" text @click="save()" :loading="loading") Save
</template>

<script>
import { mapActions } from 'vuex';
export default {
    props: {
        item: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            form: {
                value: 0
            }
        };
    },
    methods: {
        async save() {
            this.loading = true;
            try {
                if(this.form.value > 0) {
                    await this.createNewRoles({
                        user_id: this.item.id,
                        points_map_id: 0,
                        points: this.form.value
                    });
                    this.dialog = false;
                    this.$emit('success');
                }
            } catch(err) {
                this.$emit('error', err);
            } finally {
                this.loading = false;
            } 
        },
        ...mapActions('bh-user-points', { createNewRoles: 'create' }),
    }
}
</script>